import * as React from 'react';
import { Box, Typography, Button, InputLabel, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import { Formik } from 'formik';

const SentEmailContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '420px',
  height: '510px',
  marginTop: '-6px',
  marginRight: '-7px',
  background: 'rgba(0, 0, 0, 0.5)',

  [theme.breakpoints.down('md')]: {
    width: '400px',
    background: 'transparent',
    marginTop: '0px',
    marginRight: '0px',
  },

  [theme.breakpoints.down('400')]: {
    width: '340px',
    height: '450px',
    background: 'transparent',
    marginTop: '0px',
    marginRight: '0px',
  },
}));

const SentEmailText = styled(Typography)(({ theme }) => ({
  width: '70%',
  display: 'flex',
  alignItems: 'center',
  marginLeft: '47px',
  marginTop: '30px',
  color: 'rgba(255, 255, 255, 0.7)',
  fontFamily: 'Raleway',
  fontSize: '14px',
  lineHeight: '20px',

  [theme.breakpoints.down('md')]: {
    width: '80%',
    marginLeft: '35px',
    marginTop: '30px',
    fontSize: '16px',
    lineHeight: '18px',
  },

  [theme.breakpoints.down('350')]: {
    width: '80%',
    marginLeft: '30px',
    marginTop: '30px',
    fontSize: '13px',
    lineHeight: '18px',
  },
}));

const SentEmailTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '47px',
  marginTop: '95px',
  color: '#FFFFFF',
  fontFamily: 'Fjalla One',
  fontSize: '20px',
  lineHeight: '25px',

  [theme.breakpoints.down('md')]: {
    //-10px
    fontSize: '22px',
    lineHeight: '27px',
    marginLeft: '35px',
  },

  [theme.breakpoints.down('350')]: {
    marginLeft: '30px',
    marginTop: '45px',
    fontSize: '19px',
    lineHeight: '25px',
  },
}));

const RetryButton = styled(Button)(({ theme }) => ({
  width: '82px',
  height: '23px',
  textTransform: 'none',
  fontFamily: 'Fjalla One',
  fontSize: '14px',
  lineHeight: '18px',
  marginLeft: '46px',
  marginTop: '35px',
  color: '#FFFFFF',
  backgroundColor: '#AA9178',
  borderRadius: '0',

  [theme.breakpoints.down('md')]: {
    marginLeft: '35px',
    fontSize: '16px',
    lineHeight: '20px',
    width: '100px',
    height: '30px',
  },

  [theme.breakpoints.down('350')]: {
    marginLeft: '30px',
    marginTop: '30px',
    fontSize: '13px',
    lineHeight: '16px',
    width: '75px',
    height: '30px',
  },
}));

export default function SentEmailDisplay(props) {
  return (
    <SentEmailContainer>
      <SentEmailTitle> ✓ Reset email has been sent</SentEmailTitle>
      <SentEmailText>
        A password reset email has been sent to the email address on file for your account, but may
        take several minutes to show up in your inbox. Please wait at least 10 minutes before
        attempting another reset.
      </SentEmailText>
      <RetryButton type="submit" onClick={() => props.handlePageChange('LOGIN')}>
        Retry Login
      </RetryButton>
    </SentEmailContainer>
  );
}
